const favourite_day  = `Yksi elämäni parhaista päivistä oli, kun poikani syntyi.
Se oli päivä täynnä iloa ja onnea, jota en koskaan unohda.
Kun poikani syntyi, tunsin rakkautta, jota en ollut koskaan ennen tuntenut.
Olin niin onnellinen nähdessäni hänet ja pitäessäni häntä sylissäni ensimmäistä kertaa.
Se oli erityinen hetki, jota tulen aina vaalimaan.
Perhe ja ystävät tulivat juhlimaan erityistä päivää kanssamme.
He toivat lahjoja ja jakoivat rakkautensa ja tukensa, mikä teki päivästä entistä ikimuistoisemman ja iloisemman.
Muistan sen onnen ja jännityksen, joka täytti huoneen, kun poikani saapui.
Se oli puhtaan ilon ja rakkauden tunne, jota tulen aina pitämään lähellä sydäntäni.
Päivä, jolloin poikani syntyi, oli päivä täynnä rakkautta, toivoa ja uusia alkuja.
Se oli päivä, joka muutti elämäni lopullisesti ja toi niin paljon onnea ja merkitystä maailmaani.`;

export default favourite_day;